<ft-modal-editor-wrapper [canSave]="false" [theme]="theme">
    <ng-template #triggerTmpl>
        <ng-content></ng-content>
    </ng-template>
    <ft-monthly-daterange-picker
        [fromDate]="value?.startDate"
        [toDate]="value?.endDate"
        [theme]="theme"
        (changed)="onDateRangeChanged($event)"
        *ngIf="visible">
    </ft-monthly-daterange-picker>
</ft-modal-editor-wrapper>
